export default __webpack_public_path__ + "static/Implementation-Testing-5be059ed82fe28cb025f404d06c781cc.webp";